import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import store from './store/index';
import '@/assets/js/http';
import {Toast} from 'vant';
import 'vant/lib/toast/style';
import {PaymentBrand} from '@/assets/js/common';
import httpPlugin from '@/assets/js/http';
import Loading from '@/assets/js/loading';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import {WagmiPlugin} from '@wagmi/vue';
import {QueryClient, VueQueryPlugin} from '@tanstack/vue-query';
import {wagmiAdapter} from '@/config/wagmiConfig';

const coverString = (subStr, str) => new RegExp(subStr, 'i').test(str);

const getPaymentBrand = () => {
  const {host} = window.location;
  if (coverString('allo', host)) return PaymentBrand.ALLOPAY.name;
  if (coverString('tena', host)) return PaymentBrand.TENAPAY.name;
  if (coverString('kuku', host)) return PaymentBrand.KUKUCHIP.name;
  return PaymentBrand.TIKIPAY.name;
};

localStorage.setItem('paymentBrand', getPaymentBrand());
i18n.global.locale = localStorage.lang || 'en-US';

const path = window.location.pathname;
const newAppPages = [
  '/demo', '/id/demo', '/ph/demo', '/th/demo',
  '/my/demo', '/vn/demo', '/la/demo', '/mx/spei',
  '/ep/demo', '/gcash',
];

if (newAppPages.includes(path)) {
  import('./assets/css/demo.scss');
} else {
  import('./assets/css/checkout.scss');
}

// 全局插件注册
const app = createApp(App);

const queryClient = new QueryClient();

app.use(Loading).
    use(WagmiPlugin, {config: wagmiAdapter.wagmiConfig}).
    use(VueQueryPlugin, {queryClient}).
    use(Toast).
    use(router).
    use(store).
    use(i18n).
    use(httpPlugin).
    use(ElementPlus);
app.mount('#app');